import { render, staticRenderFns } from "./ResumeTag.vue?vue&type=template&id=39759873"
import script from "./ResumeTag.vue?vue&type=script&lang=js"
export * from "./ResumeTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39759873')) {
      api.createRecord('39759873', component.options)
    } else {
      api.reload('39759873', component.options)
    }
    module.hot.accept("./ResumeTag.vue?vue&type=template&id=39759873", function () {
      api.rerender('39759873', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/Modal/ResumeTag.vue"
export default component.exports